import { Injectable } from '@angular/core';
import { Feature } from 'ol';
import { LineString } from 'ol/geom';
import { MapSharedService } from './map-shared.service';
import { ParityValue } from './resolution-qc.service';
import { AttrIndexService } from './attr-index.service';
import { LayerCategory, LayerCategoryStandardSchema } from './field-mapping.service';
import { CenterlineSide } from './resolution-center.service';
import { UserService } from './user.service';
import { EditService } from './edit.service';
import { AgencyInfoService } from './agency-info.service';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EditFeatureService {

	showPolygonEditBS: BehaviorSubject<{
		showEditContextmenu: boolean;
		menuText?: string;
	}> = new BehaviorSubject({
		showEditContextmenu: false
	});
	polygonEditSubject: Subject<{
		activate: boolean;
	}> = new Subject();
	bdryWizardBS: BehaviorSubject<{
		isOn: boolean;
	}> = new BehaviorSubject({
		isOn: false
	})

	constructor(
		private agencyInfoService: AgencyInfoService,
		private attrIndexService: AttrIndexService,
		private editService: EditService,
		private mapSharedService: MapSharedService,
		private userService: UserService
	) { }

	getAddressNumInterpolate(pointOnRoad: number[], lineFeat: Feature<LineString>, addrRange: number[], parity: ParityValue) {
		const splitLine = this.mapSharedService.getSplitLineByPoint(lineFeat, pointOnRoad).first;
		const percent = splitLine.getLength() / lineFeat.getGeometry().getLength();
		let addrNum = addrRange[0] + (addrRange[1] - addrRange[0]) * percent;
		addrNum = this.roundAddressNumByParity(addrNum, parity) // Number(addrNum.toFixed(0));
		return addrNum;
	}
	roundAddressNumByParity(rawNum: number, parity: ParityValue) {
		const floor = Math.floor(rawNum);
		switch (parity) {
			case 'O':
				if (floor % 2 === 1) {
					return floor;
				} else {
					return floor + 1;
				}
			case 'E':
				if (floor % 2 === 0) {
					return floor;
				} else {
					return floor + 1;
				}
			default:
				return Math.round(rawNum);
		}
	}

	checkRoadRangeValid(range: number[]) {
		if (!range || range.length < 2) {
			return false;
		}
		if (range[0] === range[1]) {
			return false;
		}
		if ((!range[0] && range[0] !== 0) || (!range[1] && range[1] !== 0)) {
			return false;
		}
		return true;
	}

	carryOverCenterlineAttrsToAddress(lineAttrs, side: CenterlineSide, addressCate: LayerCategory, centerlineCate: LayerCategory, addrFeat?: Feature, isRelocation?: boolean) {
		const props = {};
		let cols = addressCate.standardCols;
		if (isRelocation) {
			cols = cols.filter(i => i.isFishboneCol || i.transferRclVal !== 'calc');
		}
		cols.forEach(i => {
			let lineCol: LayerCategoryStandardSchema;
			if (i.transferRclCol) {
				lineCol = centerlineCate.standardCols.find(c => c.colName === i.transferRclCol)
			}
			const addrProp = addressCate.colPrefix + '_' + i.colName.toLowerCase();
			const prop = {};
			switch (i.transferRclVal) {
				case 'transfer':
					let colName = i.transferRclCol || i.colName;
					lineCol = centerlineCate.standardCols.find(c => c.colName === colName)
					break;
				case 'parity':
					let colNameWithSide = i.transferRclCol + (side === 'left' ? '_l' : '_r');
					lineCol = centerlineCate.standardCols.find(c => c.colName.toLowerCase() === colNameWithSide.toLowerCase());
					break;
			}
			if (lineCol) {
				const lineColProp = centerlineCate.colPrefix + '_' + lineCol.colName.toLowerCase();
				prop[addrProp] = lineAttrs[lineColProp];
			}
			if (i.transferRclVal === 'calc') {
				switch (i.colName.toLowerCase()) {
					case this.attrIndexService.discrepancyAgencyIdStandardLower:
						const discAgencyId = this.userService.customerInfo.discrepancyId;
						prop[addrProp] = discAgencyId;
						break;
					case this.attrIndexService.dateUpdateCol.toLowerCase():
						prop[addrProp] = this.editService.convertDateToStr(new Date())
						break;
					case this.attrIndexService.nguidCol.toLowerCase():
						// const pattern = {
						// 	layerType: this.agencyInfoService.getIsLayerTypeFromNguidPattern(this.userService.customerInfo.nguidPattern)
						// }
						const nguid = this.agencyInfoService.computeNguid(addressCate.code)
						prop[addrProp] = nguid;
						break;
					// todo: latitude/longitude
				}
			}
			if (addrFeat) {
				addrFeat.setProperties(prop);
			}
			if (prop[addrProp] !== undefined) {
				props[addrProp] = prop[addrProp];
			}
		});
		return props;
	}
}
